import script from "./Trash.vue?vue&type=script&setup=true&lang=js"
export * from "./Trash.vue?vue&type=script&setup=true&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=14bae801&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bae801"]])

export default __exports__